import React from 'react'
import { mount } from '../utils/mount'
import { FaqPage } from '../pages/faq-page'

mount('#page-root', <FaqPage />)